// MARK://dhk8/pos/lib/queries/modifiers
// Queries tipadas de grupos de modificadores — F4.4 / ADR-0009. El POS lee los grupos
// por el grafo (catalog-modifiers, tenant del JWT) — mismas queries que Admin. Escrituras
// (grupos/opciones/links) siguen REST. Campos inline (el preset `client` de codegen NO
// evalúa interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosModifierGroupsForProductQuery = graphql(`
  query PosModifierGroupsForProduct($productId: ID!) {
    modifierGroupsForProduct(productId: $productId) {
      id tenantId name minSelect maxSelect isRequired active createdAt updatedAt deletedAt
      options { id groupId label priceDeltaCents nestedGroupId active sortOrder }
    }
  }
`);

export const PosModifierGroupsQuery = graphql(`
  query PosModifierGroups($q: String, $page: Int, $limit: Int) {
    modifierGroups(q: $q, page: $page, limit: $limit) {
      total
      items {
        id tenantId name minSelect maxSelect isRequired active createdAt updatedAt deletedAt
        options { id groupId label priceDeltaCents nestedGroupId active sortOrder }
      }
    }
  }
`);
